import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
export * from './Respuesta.types'
import { IRespuesta } from './Respuesta.lib';

export class Respuesta extends IRespuesta {

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Respuesta>; Error?: boolean; }> {

        let a: Array<Respuesta> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/cursos/respuestas` );
        request.params = params;
        if ( await request.get() ) {
            if ( request.data.response ) {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results ) {
                for ( let i of request.data.results ) {
                    let p = new Respuesta( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }
}